module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_SE.570f1f9e.txt";